export default "__VITE_ASSET__Cps0HBsz__"